import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router';
import { AdminConfigPermissions } from '@connect-x-app/shared-domain-models';
import { ADMIN_TEST_IDS } from '@connect-x-app/web-test-ids';

import { Tab, TabRouter } from '../../shared/tabRouter/TabRouter';

export const General: FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const tabs: Tab[] = useMemo(() => {
    return [
      {
        label: t('TAB.GENERAL.SMART_ACTIONS'),
        name: 'smartActions',
        order: 0,
        permissions: [AdminConfigPermissions.VIEW],
        url: '/admin/connect/general/smart-actions',
      },
      {
        label: t('QUICK_REPLIES.LABEL_other'),
        name: 'quickReplies',
        order: 1,
        permissions: [AdminConfigPermissions.VIEW],
        url: '/admin/connect/general/quick-replies',
      },
      {
        label: t('TAB.GENERAL.SYSTEM_MESSAGES'),
        name: 'systemMessages',
        order: 2,
        permissions: [AdminConfigPermissions.VIEW],
        url: '/admin/connect/general/system-messages',
      },
      {
        label: t('TAB.GENERAL.CHANNELS'),
        name: 'channels',
        order: 3,
        permissions: [AdminConfigPermissions.VIEW],
        url: '/admin/connect/general/channels',
      },
    ];
  }, [t]);

  const showTabs = useMemo(() => tabs.some(t => t.url === location.pathname), [tabs, location.pathname]);

  return (
    <>
      {/* Empty div for testing purposes. This is the one used for checking the rendering in jest tests */}
      <div data-test={ADMIN_TEST_IDS.general.page} />
      {showTabs ? <TabRouter tabs={tabs} /> : null}
      <Outlet />
    </>
  );
};
